<template>
  <span class="copyable-id d-inline-flex align-center" :title="fullId">
    <span class="copyable-id__label">
      <template v-if="showTypeLabel">{{ type }} ID: </template>{{ abbreviatedId }}
    </span>
    <v-icon
      v-if="fullId"
      x-small
      class="copyable-id__icon ml-1"
      :title="$t('reports.copyToClipboard')"
      @click.stop="copyId"
    >mdi-content-copy</v-icon>
  </span>
</template>

<script>
import { useSnackbarStore } from '@/store/index'

export default {
  name: 'CopyableId',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    type: {
      type: String,
      required: true
    },
    numberOfCharts:{
      type: Number,
      default: 12
    }
  },
  computed: {
    fullId () {
      return this.id === null || this.id === undefined ? '' : String(this.id)
    },
    abbreviatedId () {
      return this.fullId && this.numberOfCharts < 50 ? `${this.fullId.slice(0, this.numberOfCharts)}...` : this.fullId ? this.fullId : '-' 
    },
    showTypeLabel () {
      return !['broker', 'bank', 'company'].includes(this.type.trim().toLowerCase())
    }
  },
  methods: {
    async copyId () {
      if (!this.fullId) return

      try {
        await navigator.clipboard.writeText(this.fullId)
        useSnackbarStore().open(this.$t('reports.idCopied', { type: this.type }), 'success')
        this.$emit('copied', this.fullId)
      } catch (error) {
        useSnackbarStore().open(this.$t('reports.copyFailed'), 'error')
      }
    }
  }
}
</script>

<style scoped>
.copyable-id {
  white-space: nowrap;
}

.copyable-id__icon {
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.copyable-id:hover .copyable-id__icon,
.copyable-id__icon:focus {
  opacity: 1;
}

@media (hover: none) {
  .copyable-id__icon {
    opacity: 1;
  }
}
</style>
